var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"100px"}}),_c('b-container',{staticClass:"mt--7",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('light-table')],1)],1),_c('div',{staticClass:"mt-5"}),_c('dark-table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }